export enum ExportSimilaritiesListTypesEnum {
  KNM_MATCH_BY_KNM = 'KNM_MATCH_BY_KNM',
  KNM_MATCH_BY_PLAN_ALL = 'KNM_MATCH_BY_PLAN_ALL',
  KNM_MATCH_BY_PLAN = 'KNM_MATCH_BY_PLAN',
}
